import { EventTarget, defineEventAttribute } from 'event-target-shim'
import TextTrack from '../TextTrack/TextTrack'

class TextTrackList extends EventTarget {
  static fromTrackOptions = (trackOptions, player) =>
    new TextTrackList(trackOptions.map((options) => new TextTrack(options, player)))

  constructor(tracks = []) {
    super()

    this.tracks_ = []

    Object.defineProperty(this, 'length', {
      get() {
        return this.tracks_.length
      },
    })

    for (let i = 0; i < tracks.length; i++) {
      this.addTrack(tracks[i])
    }
  }

  onTrackLoaded = ({ detail = {} }) => {
    if (detail.errors && detail.errors.length) {
      // > Not part of the spec: Errors are emitted for logging
      this.dispatchEvent(new CustomEvent('trackloaderror', { detail }))
    }
  }

  onModeChange = () => this.dispatchEvent(new CustomEvent('change'))

  addTrack(track) {
    // Do not add duplicate tracks
    if (this.tracks_.indexOf(track) === -1) {
      track.addEventListener('trackloaded', this.onTrackLoaded)
      track.addEventListener('modechange', this.onModeChange)

      const index = this.tracks_.length
      if (!('' + index in this)) {
        Object.defineProperty(this, index, {
          get() {
            return this.tracks_[index]
          },
        })
      }

      this.tracks_.push(track)
      this.dispatchEvent(new CustomEvent('addtrack'))
    }
  }

  removeTrack(track) {
    for (let i = 0, l = this.length; i < l; ++i) {
      if (this[i] === track) {
        this.tracks_.splice(i, 1)
        removeTrackListeners(this, track)
        this.dispatchEvent(new CustomEvent('removetrack'))
        break
      }
    }
  }

  // Not part of the spec, but used to unbind all event listeners
  removeInternalListeners() {
    for (let i = 0, l = this.length; i < l; ++i) {
      removeTrackListeners(this, this[i])
    }
  }

  getTrackById(id) {
    for (let i = 0, l = this.length; i < l; ++i) {
      const track = this[i]
      if (track.id === id) {
        return track
      }
    }
    return null
  }
}

const removeTrackListeners = (trackList, track) => {
  track.removeEventListener('trackloaded', trackList.onTrackLoaded)
  track.removeEventListener('modechange', trackList.onModeChange)
  track.removeInternalListeners && track.removeInternalListeners()
}

defineEventAttribute(TextTrackList.prototype, 'change')
defineEventAttribute(TextTrackList.prototype, 'addtrack')
defineEventAttribute(TextTrackList.prototype, 'removetrack')

export default TextTrackList
